// extracted by mini-css-extract-plugin
module.exports = {"item":"item-2jqrK","info":"info-1cyrO","type":"type-3vTAE","icon":"icon-QnxMn","selected":"selected-k3Tg7"};